import { render, staticRenderFns } from "./AdminAcceptedPurchaseOffers.vue?vue&type=template&id=74a4cb32&scoped=true&"
import script from "./AdminAcceptedPurchaseOffers.vue?vue&type=script&lang=js&"
export * from "./AdminAcceptedPurchaseOffers.vue?vue&type=script&lang=js&"
import style0 from "./AdminAcceptedPurchaseOffers.vue?vue&type=style&index=0&id=74a4cb32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a4cb32",
  null
  
)

export default component.exports